import { ToastType } from './toast-type';

export class Toast {

    constructor(public type: ToastType,
                public msg: string,
                public error?: any,
                public subtitle?: string) {
    }
}